import React, {Component} from 'react'

import PaperBlock from "../../ui/PaperBlock"

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import TablePagination from '@material-ui/core/TablePagination'

/**
 *  <OutcomeList
 *    items
 *    itemsAmount
 *    itemsPerPage
 *    page
 *    onChangePage={page}
 *    onClickItem={item}
 *  />
 */

class OutcomeList extends Component {

  render() {
    return <PaperBlock>
      <List>
        {this.props.items.map((item, n) => <ListItem
          key={n}
          button
          onClick = {e => {
            e.stopPropagation()
            if (typeof this.props.onClickItem === "function") {
              this.props.onClickItem(item)
            }
          }}
        >
          <ListItemText
            primary={item.item ? item.item.name : "null"}
            secondary={item.date}
          />
          <div>{item.amount}</div>
        </ListItem>)}
      </List>
      <TablePagination
        component="div"
        page={this.props.page}
        rowsPerPage={this.props.itemsPerPage}
        rowsPerPageOptions={[]}
        count={this.props.itemsAmount}
        onChangePage={(e, page) => {
          if (typeof this.props.onChangePage) {
            this.props.onChangePage(page)
          }
        }}
      />
    </PaperBlock>
  }

}

export default OutcomeList
